import { createPortal } from "react-dom";
import { X } from "lucide-react";

const ModalModel = ({
  title = "",
  icon = null,
  active = true,
  topContent = null,
  onClose,
  children,
  /** Largeur ~90 % (réduction ~10 %) */
  compact = false,
  /** Corps scrollable (clavier mobile) */
  scrollable = true,
}) => {
  const handleClose = () => {
    if (typeof onClose === "function") onClose();
  };

  // Fermée = absente du DOM (évite le flash « Partage et gagne » au overscroll mobile).
  if (!active) return null;

  // Portal hors des parents overflow/transform pour un vrai fixed viewport.
  if (typeof document === "undefined") return null;

  const sheetWidth = compact
    ? "w-[90%] max-w-[585px]"
    : "w-full max-w-[650px]";

  return createPortal(
    <div className="fixed inset-0 z-[1000] flex items-end justify-center pb-[env(safe-area-inset-bottom)]">
      <div
        className="fixed inset-0 bg-black bg-opacity-70 transition-opacity duration-300 ease-in-out"
        onClick={handleClose}
        aria-hidden
      />
      <div
        className={`relative ${sheetWidth} max-h-[90vh] flex flex-col animate-slide-up ${
          compact ? "mb-3" : ""
        }`}
      >
        {topContent}
        <div className="modal-content bg-white rounded-t-[20px] w-full shadow-lg flex flex-col max-h-[90vh] overflow-hidden">
          <div className="py-2.5 px-3 relative shrink-0">
            <div className="bg-white rounded-t-3xl px-4 pt-1 pb-2 relative">
              <div className="flex items-center justify-center gap-2">
                {icon && (
                  <div className="flex items-center justify-center w-5 h-5">{icon}</div>
                )}
                <h2 className="text-lg font-bold leading-none">{title}</h2>
              </div>
            </div>
            <button
              type="button"
              onClick={handleClose}
              className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded-full bg-gray-50 text-gray-700 hover:bg-gray-100 transition-colors duration-200"
              aria-label="Fermer"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          <div
            // `pt-1` : sans lui, la première ligne du contenu affleure le bord
            // de la zone défilante et se fait couper net par l'en-tête.
            className={`px-3 pt-1 pb-4 ${
              scrollable
                ? "overflow-y-auto overscroll-contain flex-1 min-h-0 [-webkit-overflow-scrolling:touch]"
                : ""
            }`}
          >
            {children}
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ModalModel;
